import Page from "../../../../components/Layout/Page";
import T from "../../../../components/Typography";
import { useIsMobile } from "../../../../helpers/ui";
import { SectionFlexRow } from "../../../../components/General";
import { colors } from "../../../../styles";
import { useNavigate } from "react-router-dom";
import { DesktopHeader, MobileHeader } from "../Account/components";
import { ReactComponent as ArrowRight } from "../../../../assets/fullarrowright.svg";
import useGetAccount from "../../../../hooks/queries/employee/useGetAccount";
import { employeeSettingsPath } from "../../../../routes/paths";
import useGetAccountStatements from "../../../../hooks/queries/employee/useGetAccountStatements";
import Loader from "../../../../components/Loader";
import ErrorPage from "../../../../components/ErrorPage";
import HeaderBreadcrumbs from "../../../../components/HeaderBreadcrumbs";
import ResponsePageContent from "../../../../components/Layout/ResponsivePageContent";

const AccountStatements = () => {
  const { data: accountData } = useGetAccount();
  const { data, status } = useGetAccountStatements(
    accountData?.challenger_saving.account_number
  );
  const isMobile = useIsMobile();
  const navigate = useNavigate();
  const breadcrumbs = ["Profile & Settings", "Statements"];

  if (status === "loading") return <Loader />;
  if (status === "error") return <ErrorPage />;

  const reversedData = [...data].reverse();
  return (
    <Page>
      {isMobile ? (
        <MobileHeader title="Statements" showBack showClose={false} />
      ) : (
        <DesktopHeader>
          <HeaderBreadcrumbs
            breadcrumbs={breadcrumbs}
            handleBack={() => navigate(employeeSettingsPath)}
          />
        </DesktopHeader>
      )}
      <ResponsePageContent title="Statements" subtitle="Month-by-month">
        {reversedData.map((statement, index) => {
          return (
            <SectionFlexRow
              key={index}
              sx={{
                justifyContent: "space-between",
                height: "60px",
                borderBottom: `1px solid ${colors.gray_200}`,
                cursor: "pointer",
              }}
              onClick={() => navigate(statement.url_slug)}
            >
              <T>{statement.month_name_readable}</T>
              <ArrowRight />
            </SectionFlexRow>
          );
        })}
      </ResponsePageContent>
    </Page>
  );
};

export default AccountStatements;
